export default "__VITE_ASSET__c70dbda7__"